import { render, staticRenderFns } from "./colalist.vue?vue&type=template&id=0a8489f8&scoped=true&"
import script from "./colalist.vue?vue&type=script&lang=js&"
export * from "./colalist.vue?vue&type=script&lang=js&"
import style0 from "./colalist.vue?vue&type=style&index=0&id=0a8489f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8489f8",
  null
  
)

export default component.exports